var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebglnew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.895,
    height: 19.597,
    viewBox: "0 0 19.895 19.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "webgl",
    transform: "translate(-0.133 -0.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2948",
    "data-name": "Group 2948",
    transform: "translate(-7.067 -2.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14179",
    "data-name": "Path 14179",
    d: "M16.311,18.841V15.5h1.212l-.042-.9h-1.17V11.59h3.2a10.253,10.253,0,0,1-.084,1.149.742.742,0,0,1,.188.084l.669.313a12.193,12.193,0,0,0,.1-1.525h3.2a8.1,8.1,0,0,1-.669,2.758l.815.376a8.5,8.5,0,0,0,.773-3.573,8.625,8.625,0,1,0-6.833,8.442l-.063-1.672A2.716,2.716,0,0,1,16.311,18.841Zm7.272-8.15H20.407a15.218,15.218,0,0,0-.355-3.009h2.737A7.841,7.841,0,0,1,23.583,10.691ZM22.287,6.8H19.821a8.427,8.427,0,0,0-1.546-3.03A7.958,7.958,0,0,1,22.287,6.8ZM16.311,3.461c1.045.293,1.985,1.546,2.57,3.343h-2.57Zm0,4.242h2.821a14.962,14.962,0,0,1,.4,3.009H16.311ZM13.448,3.775A8.427,8.427,0,0,0,11.9,6.8H9.436A7.871,7.871,0,0,1,13.448,3.775ZM8.914,7.7h2.737a15.032,15.032,0,0,0-.355,3.009H8.119A7.647,7.647,0,0,1,8.914,7.7ZM8.119,11.59h3.2a15.031,15.031,0,0,0,.355,3.009H8.914A7.647,7.647,0,0,1,8.119,11.59ZM9.436,15.5H11.9a8.427,8.427,0,0,0,1.546,3.03A7.986,7.986,0,0,1,9.436,15.5Zm5.976,3.343c-1.066-.293-1.985-1.546-2.57-3.343h2.57Zm0-4.242H12.591a14.962,14.962,0,0,1-.4-3.009h3.218Zm0-3.908H12.194a14.962,14.962,0,0,1,.4-3.009h2.821Zm0-3.887h-2.57c.585-1.8,1.525-3.072,2.57-3.343Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_41",
    "data-name": "Polygon 41",
    d: "M3.628,1.549a1,1,0,0,1,1.743,0l2.79,4.96A1,1,0,0,1,7.29,8H1.71A1,1,0,0,1,.838,6.51Z",
    transform: "translate(27.095 13.097) rotate(90)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebglnew);
export default __webpack_public_path__ + "static/media/webglnew.2edb7ae635d11430b07f0e1b807681f4.svg";
export { ForwardRef as ReactComponent };